export const PercentileMoves = {
    label: null,
    values: [
        {
            label: 'Top 1% Moves',
            value: {
                lower: 0.01,
                upper: 0.99
            },
        },
        {
            label: 'Top 3% Moves',
            value: {
                lower: 0.03,
                upper: 0.97
            },
        },
        {
            label: 'Top 5% Moves',
            value: {
                lower: 0.05,
                upper: 0.95
            },
        },
        {
            label: 'Top 10% Moves',
            value: {
                lower: 0.10,
                upper: 0.90
            },
        },
        {
            label: 'Top 20% Moves',
            value: {
                lower: 0.20,
                upper: 0.80
            },
        },
        {
            label: 'All Moves',
            value: {
                lower: 0.50,
                upper: 0.50
            },
        },
    ],
};

export const InfoScore = {
    label: null,
    values: [
        {
            label: 'Very High Info Score',
            value: 5,
        },
        {
            label: 'High (or better) Info Score',
            value: 4,
        },
        {
            label: 'Medium (or better) Info Score',
            value: 3,
        },
        {
            label: 'Low (or better) Info Score',
            value: 2,
        },
        {
            label: 'Very Low (or better) Info Score',
            value: 1,
        },
        {
            label: 'All',
            value: 0,
        },
    ],
};